import { createGlobalStyle } from "styled-components";

import RethinkSans from "./RethinkSans";

export default createGlobalStyle`
    ${RethinkSans}
`;
